import { render, staticRenderFns } from "./OilHistory.vue?vue&type=template&id=97ae9512&scoped=true"
import script from "./OilHistory.vue?vue&type=script&lang=js"
export * from "./OilHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ae9512",
  null
  
)

export default component.exports